import { Component, Output, EventEmitter, Input } from '@angular/core';
import { AddressChangeFormComponent } from '../address-change-form/address-change-form.component';
import { NgClass } from '@angular/common';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
    selector: 'app-address-change-drawer',
    templateUrl: './address-change-drawer.component.html',
    styleUrls: ['./address-change-drawer.component.scss'],
    imports: [TranslocoDirective, NgClass, AddressChangeFormComponent]
})
export class AddressChangeDrawerComponent {
  @Output() cancelEditing = new EventEmitter();
  @Output() continueEditing = new EventEmitter();
  @Output() closed = new EventEmitter<boolean>();
  @Output() success = new EventEmitter<boolean>();
  @Output() sendError = new EventEmitter<boolean>();

  @Input() variant: 'title' | 'physical';
  @Input() open = false;

  showError = false;

  get isTitle() {
    return this.variant === 'title';
  }

  get isPhysical() {
    return this.variant === 'physical';
  }

  receiveError(data) {
    this.showError = data;
    this.sendError.emit(this.showError);
  }

  cancel() {
    this.closed.emit();
  }
}
